import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "upload-file",
  "use": "upload-file-usage",
  "viewBox": "0 0 11 14",
  "content": "<symbol viewBox=\"0 0 11 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"upload-file\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.91054 3.00926L9.21049 6.30921L10.2856 5.23489L5.14279 0.0921021L0 5.23489L1.07503 6.30921L4.37498 3.00926V10.7612H5.91054V3.00926ZM9.36376 12.373H0.921021V13.9079H9.36376V12.373Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol